import React from 'react'
import styled from 'styled-components'

const Zap = styled.div`
margin-top: 25rem;
margin-bottom: 20rem;
`

function creditos() {
  return (
    <>
    <Zap>
    <a href="https://www.freepik.com/photos/wood-craft">Wood craft photo created by freepik - www.freepik.com </a> <br/>
    <a href="https://www.freepik.com/photos/chisel">Chisel photo created by pressfoto - www.freepik.com</a>
    </Zap>
    </>
  )
}

export default creditos